import Calculator from "./Calculator";

const CalculatorEmail = {
    init(el) {
        this.el = el;
        if (!this.el.length) return;

        this.template = this.el.find('.emailMessage');
        this.input = this.el.find('input[type="hidden"][name="calculator"]')
    },

    fill() {
        const form = this.el.find('form').serializeArray();
        const check = $('<img src="' + WEB_ROOT + '/files/Icons/icon.check.png"/>')
        $.each(form, (i, item) => {
            const field = this.template.find('.' + item.name)

            if (item.value === "on") {
                check.clone().appendTo(field);
            } else {
                field.text(item.value);
            }
        });

        const message = this.template.html();

        this.input.val(message);
        localStorage.setItem("calcMessage", message);
    },

    saveResults(){
        const result = this.el.find('.slide[order="6"]').clone();
        result.find('h4, .desc, small').remove();
        localStorage.setItem("calcResult", result.html());
    }
}

export default CalculatorEmail;
